<template>
  <div class="box">
    <div class="floor1">
      <div class="content">
        <img src="../../assets/img/introduction/yh.svg" alt="" class="yh" />
        <img
          src="../../assets/img/introduction/descroption.svg"
          alt=""
          class="descroption"
        />
        <div class="title">Group description</div>
      </div>
    </div>
    <div class="floor2">
      <div class="title1 title_line">Group saving with higher interest</div>
      <div class="title2">Save together, achieve more!</div>
      <div class="list_box" v-for="item in list" :key="item.key">
        <img :src="item.img" alt="" />
        <div class="txt_box">
          <div class="title">{{ item.title }}</div>
          <div class="txt">{{ item.txt }}</div>
        </div>
      </div>
    </div>
    <div class="floor3">
      <div class="title1 title_line">Group member and manager</div>
      <div class="list">
        You can create your own group and invite your friends
      </div>
      <div class="list">
        The group has three roles: owner, manager and member.The owner can set
        up managers and delete managers. Owner and managers can agree members to
        join.All members can invite friends to join through the phone address
        book.
      </div>
    </div>
    <div class="el-loading-mask" v-if="!hasToken">
      You are not logged in. Please log in to view the page
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hasToken: false,
    };
  },
  created() {
    let o = this.$route.query;
    if (o.token) {
      this.hasToken = true;
    } else {
      this.hasToken = false;
      return false;
    }
  },
  computed: {
    list: () => {
      const img1 = require("../../assets/img/introduction/group.svg");
      const img2 = require("../../assets/img/introduction/invite.svg");
      const img3 = require("../../assets/img/introduction/saving.svg");
      const img4 = require("../../assets/img/introduction/rate.svg");
      const img5 = require("../../assets/img/introduction/Withdraw.svg");
      return [
        {
          img: img1,
          title: "Create group",
          txt: "Quick and easy create your group",
          key: "a",
        },
        {
          img: img2,
          title: "Invite your friends",
          txt: "Invite friends to join your group, improve the group level",
          key: "b",
        },
        {
          img: img3,
          title: "Saving money",
          txt:
            "Get higher deposit interest rate when have more savings and friends",
          key: "c",
        },
        {
          img: img4,
          title: "Get up to 5% interest rate",
          txt:
            "Save together with your friends now to get a better interest rate. ",
          key: "d",
        },
        {
          img: img5,
          title: " Easy and convince deposit and Withdraw",
          txt: "Quick and easy create your group",
          key: "e",
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.title_line {
  position: relative;
  &::before {
    content: " ";
    width: 38px;
    height: 10px;
    position: absolute;
    background: #ffd169;
    left: 16px;
    top: 12px;
    z-index: -1;
  }
}
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding-top: 100px;
  padding-bottom: 20px;
  position: relative;
  .floor1 {
    width: 100%;
    height: 300px;
    background: linear-gradient(
      180deg,
      #fff2d2 0%,
      rgba(255, 250, 238, 0) 100%
    );
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    .content {
      width: 100%;
      position: relative;
      .yh {
        position: absolute;
        left: 16px;
        top: 20px;
        z-index: 1;
        height: 40px;
      }
      .descroption {
        position: absolute;
        top: 0;
        right: 16px;
        width: 109px;
      }
      .title {
        position: absolute;
        left: 16px;
        top: 48px;
        font-size: 24px;
        font-family: "rb";
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        z-index: 2;
      }
    }
  }
  .floor2 {
    margin: 0 16px;
    padding: 24px 0;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 100;
    .title1 {
      padding: 0 16px;
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
      margin-bottom: 6px;
    }
    .title2 {
      padding: 0 16px;
      font-size: 14px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 19px;
      margin-bottom: 24px;
    }
    .list_box {
      padding: 0 24px;
      margin-top: 20px;
      img {
        width: 32px;
        height: 32px;
        display: inline-block;
        vertical-align: top;
      }
      .txt_box {
        display: inline-block;
        vertical-align: top;
        width: calc(100% - 48px);
        margin-left: 16px;
        .title {
          font-size: 14px;
          font-family: "rm";
          font-weight: 500;
          color: #303f49;
          line-height: 16px;
          margin-bottom: 6px;
        }
        .txt {
          font-size: 12px;
          font-family: "rr";
          font-weight: 400;
          color: #50616c;
          line-height: 16px;
        }
      }
    }
  }
  .floor3 {
    margin: 16px;
    padding: 24px 0;
    background: #ffffff;
    border-radius: 2px;
    position: relative;
    z-index: 100;
    .title1 {
      padding: 0 16px;
      font-size: 16px;
      font-family: "rm";
      font-weight: 500;
      color: #303f49;
      line-height: 19px;
      margin-bottom: 24px;
    }
    .list {
      margin-top: 12px;
      padding: 0 14px 0 28px;
      position: relative;
      font-size: 12px;
      font-family: "rr";
      font-weight: 400;
      color: #50616c;
      line-height: 21px;
      &::before {
        content: " ";
        width: 5px;
        height: 5px;
        background: #d8d8d8;
        border-radius: 100%;
        position: absolute;
        left: 16px;
        top: 9px;
      }
    }
  }
}
</style>
